import {
    FETCH_ROUNDS,
    FETCH_ROUNDS_FAILURE,
    FETCH_ROUNDS_SUCCESS,
    RESET_ROUNDS
} from "../actions/roundActions";

export default function reducer(state = { rounds: [], error: null, loading: true }, action) {
    let error;
    switch (action.type) {
        default:
            return state;
        case FETCH_ROUNDS: {
            return { ...state, error: null, loading: true };
        }
        case FETCH_ROUNDS_SUCCESS: {
            return {
                ...state,
                rounds: action.payload,
                error: null,
                loading: false
            };
        }
        case FETCH_ROUNDS_FAILURE:
            error = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
            return { ...state, rounds: [], error: error, loading: false };
        case RESET_ROUNDS: // reset roundsList to initial state
            return { ...state, rounds: [], error: null, loading: false };
    }
}
